import { Tag } from '@cian/components';
import * as React from 'react';

import { IMultiIdTag } from '../../../state/tags/definitions/multi_id';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IMultiIdTagItemProps {
  tag: IMultiIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const MultiIdTagItem = (props: IMultiIdTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Мультиобъявление №{props.tag.value}
    </TagComponent>
  );
};
